import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSortAmountDownIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m6.29 14.29-.29.3V7a1 1 0 1 0-2 0v7.59l-.29-.3a1.0041 1.0041 0 1 0-1.42 1.42l2 2c.0951.091.2073.1624.33.21a.94.94 0 0 0 .76 0 1.0007 1.0007 0 0 0 .33-.21l2-2a1.003 1.003 0 0 0 .294-.71 1.0036 1.0036 0 0 0-.294-.71 1.0052 1.0052 0 0 0-1.0942-.2177 1.0055 1.0055 0 0 0-.3258.2177ZM11 8h10a1 1 0 1 0 0-2H11a1 1 0 1 0 0 2Zm10 3H11a1.0001 1.0001 0 0 0 0 2h10a1.0001 1.0001 0 0 0 0-2Zm0 5H11a1.0001 1.0001 0 0 0 0 2h10a1.0001 1.0001 0 0 0 0-2Z"/>
  </SvgIcon>
}

export default LineSortAmountDownIcon
